module.exports = __webpack_public_path__ + "img/2018-08-30.49f6313e.jpg";